import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function F() {
    const { useLang } = useGlobal();
    const { t } = useLang('camp');
    const lists: any[] = [
        {
            title: t('secF_list1_title'),
            desc: t('secF_list1_desc'),
        },
        {
            title: t('secF_list2_title'),
            desc: t('secF_list2_desc'),
        },
        {
            title: t('secF_list3_title'),
            desc: t('secF_list3_desc'),
        },
        {
            title: t('secF_list4_title'),
            desc: t('secF_list4_desc'),
        },
    ];
    return (
        <div id="camp-F" className={`camp-F camp-box ${css['camp-F']}`}>
            <h2 className="title">{t('secF_title')}</h2>
            <div className="img-box">
                <EFPicture src={'/responsive/picture/camp/6.jpg'} alt={t('secF_title')} />
            </div>
            <p className="desc">{t('secF_desc')}</p>
            <ul className="lists">
                {lists?.map((list: any, k: number) => (
                    <li className="list" key={k}>
                        <h3 className="list-title">{list?.title}</h3>
                        <p className="list-desc desc">{list?.desc}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
}
